module.exports = __webpack_public_path__ + "img/empty-state-labels.e7be758b.svg";